import { render, staticRenderFns } from "./TemplatePortraitNew.vue?vue&type=template&id=6c007132&scoped=true&"
import script from "./TemplatePortraitNew.vue?vue&type=script&lang=js&"
export * from "./TemplatePortraitNew.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePortraitNew.vue?vue&type=style&index=0&id=6c007132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c007132",
  null
  
)

export default component.exports